// @flow
import ContrastColorUpdater from "../../helper/ContrastColorUpdater";
import useThemeStylesheet from "../../hooks/useThemeStylesheet";

const MgTheme = props => {
    useThemeStylesheet(() => import("./mg.lazy.scss"));
    return <>
	    <ContrastColorUpdater/>
	    {props.children}
    </>;
};

export default MgTheme;